import React, { useState, useEffect, useContext } from "react";
import "./productsPage.css";
import Navigation from "../../components/navigation/Navigation";
import Carousel from "../../components/carousel/Carousel";
import { Col, Row, Spinner } from "react-bootstrap";
import ProductCard from "../../components/product-card/ProductCard";
import Footer from "../../components/footer/Footer";
import queryString from "query-string";
import { ProductContext } from "../../contexts/ProductContext";
import axios from "axios";
import { ENDPOINT } from "../../helpers/Helper";
import { useNavigate } from "react-router-dom";

const renderLoading = () => (
  <div style={{ display: "flex", justifyContent: "center", padding: "10rem" }}>
    <Spinner animation="border" variant="dark" />
  </div>
);

function ProductsPage() {
  const { category, type } = queryString.parse(window.location.search);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [productType, setProductType] = useState();
  const [navBackground, setNavBackground] = useState("transparent");
  const [navIcon, setNavIcon] = useState(
    "https://res.cloudinary.com/emacon-production/image/upload/v1648793433/the-outlet/THE_OUTLET_PNG_t6abcu.png"
  );

  useEffect(() => {
    setLoading(true);
    window.scrollTo(0, 0);

    console.log(category);

    axios
      .get(`${ENDPOINT}/products?categoryId=${category}`)
      .then((res) => {
        setProductType(res.data);
        setLoading(false);
      })
      .catch((err) => {
        navigate("/error");
      });
  }, [window.location.search]);

  const changeNavigationBackground = () => {
    if (window.scrollY >= 80) {
      setNavBackground("theme-color");
      setNavIcon(
        "https://res.cloudinary.com/emacon-production/image/upload/v1654424700/the-outlet/2_cx772d.png"
      );
    } else {
      setNavBackground("transparent");
      setNavIcon(
        "https://res.cloudinary.com/emacon-production/image/upload/v1648793433/the-outlet/THE_OUTLET_PNG_t6abcu.png"
      );
    }
  };

  window.addEventListener("scroll", changeNavigationBackground);

  return (
    <div className="products">
      <Navigation background={navBackground} logo={navIcon} />

      <Carousel type="hero" />

      <div className="section-1">
        <div className="filter">
          {/* <h5>
                        <i class='bx bxs-filter-alt'></i>
                        Filter
                    </h5>
                    {
                        filterDetails.map((item, index) => (
                            <div className="filter__details">
                                <h6>{item.title} :</h6>
                                <p>{item.detail}</p>
                            </div>
                        ))
                    } */}

          <h1>{type}</h1>
        </div>
        <div>
          {loading ? (
            renderLoading()
          ) : (
            <Row className="productList">
              {productType &&
                productType.data &&
                productType.data.map((item, index) => (
                  <React.Fragment key={index}>
                    {index <= 7 ? (
                      <Col xl={2} lg={4} md={3} sm={6} xs={6}>
                        <ProductCard product={item} />
                      </Col>
                    ) : null}
                  </React.Fragment>
                ))}
            </Row>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default ProductsPage;
